// WebAuthn helpers (browser API bridge)
import api from "@/lib/api";

function b64urlToBytes(b64url) {
  const b64 = b64url.replace(/-/g, "+").replace(/_/g, "/");
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const str = atob(b64 + pad);
  const bytes = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) bytes[i] = str.charCodeAt(i);
  return bytes;
}

function bytesToB64url(bytes) {
  const arr = new Uint8Array(bytes);
  let str = "";
  for (let i = 0; i < arr.length; i++) str += String.fromCharCode(arr[i]);
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function serializeCredential(cred) {
  const out = {
    id: cred.id,
    rawId: bytesToB64url(cred.rawId),
    type: cred.type,
    response: {},
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
  if (cred.response.attestationObject) {
    out.response.attestationObject = bytesToB64url(cred.response.attestationObject);
    out.response.clientDataJSON = bytesToB64url(cred.response.clientDataJSON);
  } else {
    out.response.clientDataJSON = bytesToB64url(cred.response.clientDataJSON);
    out.response.authenticatorData = bytesToB64url(cred.response.authenticatorData);
    out.response.signature = bytesToB64url(cred.response.signature);
    if (cred.response.userHandle) out.response.userHandle = bytesToB64url(cred.response.userHandle);
  }
  return out;
}

export function isWebAuthnSupported() {
  return typeof window !== "undefined" && !!window.PublicKeyCredential;
}

export async function enrollBiometric(deviceName = "Cet appareil") {
  const { data: options } = await api.post("/webauthn/register/begin");
  const publicKey = {
    ...options,
    challenge: b64urlToBytes(options.challenge),
    user: { ...options.user, id: b64urlToBytes(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map((c) => ({
      ...c, id: b64urlToBytes(c.id),
    })),
  };
  const cred = await navigator.credentials.create({ publicKey });
  const serialized = serializeCredential(cred);
  serialized.device_name = deviceName;
  await api.post("/webauthn/register/complete", serialized);
  return true;
}

export async function loginWithBiometric(email) {
  const { data: options } = await api.post("/webauthn/login/begin", { email: email || "" });
  const publicKey = {
    ...options,
    challenge: b64urlToBytes(options.challenge),
    allowCredentials: (options.allowCredentials || []).map((c) => ({
      ...c, id: b64urlToBytes(c.id),
    })),
  };
  const cred = await navigator.credentials.get({ publicKey });
  const serialized = serializeCredential(cred);
  const { data } = await api.post("/webauthn/login/complete", serialized);
  return data;
}
